import React from 'react';
import AIAgentCenterHeader from './AIAgentCenterHeader';
import AIAgentCenterSessions from './AIAgentCenterSessions';
import AIAgentCenterHistorySessions from './AIAgentCenterHistorySessions';
import AIAgentSupportContent from './AIAgentSupportContent';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';

type Props = {};

const AIAgentManage: React.FC<Props> = () => {
  const { tab } = useAIAgentCenterContext();

  return (
    <div className='container-list max-h-[calc(100vh-100px)] gap-0 border p-0'>
      <div>
        <AIAgentCenterHeader />
      </div>

      <div className='flex'>
        <div className='w-[468px] border-r'>
          {tab == 'ongoing' ? <AIAgentCenterSessions /> : <AIAgentCenterHistorySessions />}
        </div>
        <div className='flex-1'>
          <AIAgentSupportContent />
        </div>
      </div>
    </div>
  );
};

export default AIAgentManage;
